import { Injectable } from '@angular/core';
import { S3Client, PutObjectCommand, DeleteObjectCommand } from '@aws-sdk/client-s3';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
    providedIn: 'root',
})
export class S3Service {
    private s3Client: S3Client;
    private readonly bucketName = 'evobrides';

    constructor() {
        this.s3Client = new S3Client({
            region: 'sa-east-1',
            credentials: {
                accessKeyId: 'AKIARTNNZ5DMA3AYDYUT',
                secretAccessKey: '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',
            },
        });
    }

    /**
     * Faz upload de um arquivo para o S3 e retorna a URL pública do objeto.
     *
     * @param file O arquivo a ser enviado.
     * @param pasta Pasta no S3.
     * @returns A URL pública do objeto.
     */
    async uploadFile(file: File, pasta: string): Promise<string> {
        let key = `${pasta}/${uuidv4()}_${file.name}`;
        const command = new PutObjectCommand({
            Bucket: this.bucketName,
            Key: key,
            Body: file,
            ContentType: file.type,
            ACL: 'public-read', // torna o objeto público
        });

        const response = await this.s3Client.send(command);

        return `https://${this.bucketName}.s3.amazonaws.com/${key}`;
    }

    /**
     * Deleta um arquivo do S3.
     *
     * @param url A URL do arquivo a ser deletado.
     * @returns True se a operação foi bem sucedida, false caso contrário.
     */
    async deleteFile(url: string): Promise<boolean> {
        const key = url.replace(`https://${this.bucketName}.s3.amazonaws.com/`, '').replace(`https://cdn.artsys.com/`, '');

        const command = new DeleteObjectCommand({
            Bucket: this.bucketName,
            Key: key,
        });

        try {
            await this.s3Client.send(command);
            return true;
        } catch (error) {
            console.error('Erro ao deletar arquivo do S3', error);
            return false;
        }
    }
}
